export default __webpack_public_path__ + "static/media/not_found_60pq.5d75c9c1.svg";